import {compose} from 'redux';
import {connect} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Form, Message} from 'semantic-ui-react';
import {useToasts} from 'react-toast-notifications';
import {FormSelect, required} from '../../shared/forms';
import {updateStudentType} from '../../../redux/actions/student';

function UpdateStudentTypeForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const {addToast} = useToasts();

  async function submit({typeId}) {
    try {
      await props.updateStudentType(typeId);
      addToast('دوره شما با موفقیت تغییر کرد.', {appearance: 'success'});
    } catch (error) {
      const errorMessage = error.message || 'تغییر دوره انجام نشد.';
      throw new SubmissionError({_error: errorMessage});
    }
  }

  const STUDENT_TYPE_OPTIONS = [props.studentType, ...props.studentType.updatableTypes].map(
    ({id, name}) => ({name, value: id, text: name})
  );

  return (
    <div>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Field
          name='typeId'
          label='دوره'
          component={FormSelect}
          options={STUDENT_TYPE_OPTIONS}
          validate={required}
        />

        <Button
          type='submit'
          disabled={pristine || submitting}
          content='ثبت دوره'
        />
      </Form>
    </div>
  );
}

function mapStateToProps(_, {studentType}) {
  return {initialValues: {typeId: studentType.id}};
}

export default compose(
  connect(mapStateToProps, {updateStudentType}),
  reduxForm({form: 'update-student-type', enableReinitialize: true})
)(UpdateStudentTypeForm);
